<template>
  <div class="d-flex-row">
    <el-dialog
            :visible.sync="ownShow"
            title="添加品牌"
            width="50%"
            :before-close="closeFunc"
    >
      <div style="padding:14px 24px;" class="d-flex-column d-flex-center">
        <div style="padding-bottom: 14px;" class="w-100 d-flex-row d-flex-center">
          <span style="margin-right: 14px;">品牌名称</span>
          <el-input style="width: 50%" v-model="name" placeholder="请输入品牌名称"/>
        </div>
        <div class="w-100 d-flex-row d-flex-center">
          <el-button @click="pushName" type="primary">确认添加</el-button>
          <el-button @click="closeFunc">取消</el-button>
        </div>

      </div>

    </el-dialog>
  </div>
</template>
<script>
// import {ref, watch} from '@vue/composition-api';
import {addBrand} from "@/api/customers"

export default {
  name: 'addBrand',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    brands: {
      type: Array,
      default: () => []
    },
    id: {
      type: Number,
      default: null
    },
    saleId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      name: null,
      ownShow: this.show,
      ownBrands: this.brands,
    }
  },
  watch: {
    show: function () {
      this.ownShow = this.show
    },
    brands: function () {
      this.ownBrands = this.brands
    }
  },
  methods: {
    pushName: function () {
      this.name = this.name ? this.name.trim() : null
      if (this.name) {
        addBrand({
          id: this.id,
          brand: this.name,
          sale_id: this.saleId
        }).then(() => {
          if (Array.isArray(this.ownBrands)) {
            let arr = this.ownBrands
            arr.push(this.name)
            this.ownBrands = [...new Set(arr)]
          } else {
            this.ownBrands = [this.name]
          }
          this.$emit('success', [this.ownBrands, this.name])
          this.showToast({
            h: this,
            text: "添加成功",
            icon: 'el-icon-success'
          })
          this.closeFunc()
        })
          .catch((err) => {
            // eslint-disable-next-line
            console.error(err);
          });
      } else {
        this.showToast({
          h: this,
          text: "品牌名称不能为空",
          icon: 'el-icon-error'
        })
      }
    },
    closeFunc: function () {
      this.name = ''
      this.$emit('close', false)
    }
  }
}
</script>
